/* SPOTEC 360 Spin (sections/spotec-spin-360.liquid)
   - Sepatu tengah berputar 1 putaran penuh (= 1x durasi video), lalu langsung geser ke berikutnya.
   - Yang keluar tetap berputar selama bergeser lalu berhenti; yang masuk langsung berputar (tanpa patah).
   - Ringan: tanpa blend mode (latar #F7F5F5 tertanam di video), hanya video tengah + berikutnya yang dimuat,
     720p di HP, 1080p di desktop. Yang dianimasikan hanya transform & blur sepatu yang berpindah.
   - Tanpa gerak: prefers-reduced-motion, theme editor (Shopify.designMode), atau autoplay dimatikan.
   - Hemat data (Data Saver / 2G): tidak memuat video, hanya gambar + geser tiap 4 detik.
   - HP (fix 13 Okt): play() dipanggil langsung (iOS tidak memuat video sebelum play), muted/inline dipaksa.
     Kalau video diblokir (iOS Low Power Mode, autoplay mati) atau macet 2,5 dtk: tetap geser tiap 4 detik
     pakai poster, lalu dicoba putar lagi saat pengunjung menyentuh layar. */
(function () {
  if (customElements.get('spotec-spin-360')) return;

  var SLIDE_MS = 900, IMAGE_DWELL = 4, LOAD_TIMEOUT = 3, STALL = 2.5, RETRY_MS = 1000;

  function lowData() {
    var c = navigator.connection;
    return !!(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')));
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  class SpotecSpin360 extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.setup();
    }

    disconnectedCallback() {
      this._ready = false;
      cancelAnimationFrame(this._raf);
      clearTimeout(this._busyTimer);
      if (this._ioNear) this._ioNear.disconnect();
      if (this._ioView) this._ioView.disconnect();
      document.removeEventListener('visibilitychange', this._onVis);
      document.removeEventListener('shopify:block:select', this._onSelect);
      document.removeEventListener('touchend', this._onGesture);
      document.removeEventListener('click', this._onGesture);
      window.removeEventListener('resize', this._onResize);
    }

    setup() {
      var self = this;
      this.stage = this.querySelector('[data-stage]');
      this.slides = Array.prototype.slice.call(this.stage.querySelectorAll(':scope > [data-slide]'));
      this.N = this.slides.length;
      if (!this.N) return;

      this.i = 0; this.spun = 0; this.paused = false; this.inView = false; this.near = false; this.moved = false;
      this.reduce = matchMedia('(prefers-reduced-motion: reduce)').matches || !!(window.Shopify && window.Shopify.designMode);
      this.autoplay = this.dataset.autoplay === 'true' && !this.reduce;
      this.low = lowData();
      this.phone = matchMedia('(max-width: 749px)');
      this.infoTarget = this.querySelector('[data-info-target]');
      this.link = this.querySelector('[data-link]');
      this.counter = this.querySelector('[data-count]');
      this.pauseBtn = this.querySelector('[data-pause]');
      if (this.autoplay) this.classList.add('can-play');

      this.slides.forEach(function (s, k) {
        s._v = s.querySelector('video');
        s._last = null; s._wait = 0; s._still = 0; s._bad = false; s._slow = false; s._blocked = false; s._try = 0;
        if (s._v) s._v.addEventListener('error', function () { s._bad = true; }, { once: true });
        s.addEventListener('click', function (e) {
          if (self.moved) { e.preventDefault(); return; }
          if (k !== self.i) { e.preventDefault(); self.go(k, self.offset(k, 1) > 0 ? 1 : -1); }
        });
      });

      var prev = this.querySelector('[data-prev]'), next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { self.go(self.i - 1, -1); });
      if (next) next.addEventListener('click', function () { self.go(self.i + 1, 1); });
      if (this.pauseBtn) this.pauseBtn.addEventListener('click', function () { self.togglePause(); });

      this.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { self.go(self.i + 1, 1); }
        else if (e.key === 'ArrowLeft') { self.go(self.i - 1, -1); }
      });

      /* geser jari / mouse */
      var sx = null;
      this.stage.addEventListener('pointerdown', function (e) { sx = e.clientX; self.moved = false; });
      this.stage.addEventListener('pointermove', function (e) { if (sx !== null && Math.abs(e.clientX - sx) > 10) self.moved = true; });
      this.stage.addEventListener('pointerup', function (e) {
        if (sx === null) return;
        var dx = e.clientX - sx; sx = null;
        if (Math.abs(dx) > 40 && self.N > 1) self.go(self.i + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
        setTimeout(function () { self.moved = false; }, 0);
      });
      this.stage.addEventListener('pointercancel', function () { sx = null; });

      /* muat video saat hampir terlihat; jalan hanya saat terlihat */
      this._ioNear = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { self.near = true; self.loadAround(); self._ioNear.disconnect(); }
      }, { rootMargin: '300px 0px' });
      this._ioNear.observe(this);
      this._ioView = new IntersectionObserver(function (es) { self.inView = es[0].isIntersecting; self.sync(); }, { threshold: 0.35 });
      this._ioView.observe(this.stage);

      this._onVis = function () { self.sync(); };
      document.addEventListener('visibilitychange', this._onVis);
      var rz = 0;
      this._onResize = function () { cancelAnimationFrame(rz); rz = requestAnimationFrame(function () { self.layout(1, true); }); };
      window.addEventListener('resize', this._onResize);

      /* theme editor: pilih blok → tampilkan sepatunya */
      this._onSelect = function (e) {
        var k = self.slides.indexOf(e.target);
        if (k > -1 && k !== self.i) self.go(k, k > self.i ? 1 : -1);
      };
      document.addEventListener('shopify:block:select', this._onSelect);

      /* video diblokir (iOS Low Power Mode dll.): sentuhan pertama pengunjung membuka izin putar */
      this._onGesture = function () {
        var any = false;
        self.slides.forEach(function (s) { if (s._blocked) { s._blocked = false; s._still = 0; s._try = 0; any = true; } });
        if (any) { self.spun = 0; self.slides[self.i]._last = null; self.playCenter(true); }
      };
      document.addEventListener('touchend', this._onGesture, { passive: true });
      document.addEventListener('click', this._onGesture, { passive: true });

      this.layout(1, true);
      this.text();
      this.classList.add('is-ready');
    }

    offset(k, dir) {
      var N = this.N, o = ((k - this.i) % N + N) % N;
      var lim = dir < 0 ? Math.ceil((N - 1) / 2) : Math.floor((N - 1) / 2);
      if (o > lim) o -= N;
      return o;
    }

    layout(dir, instant) {
      var self = this, vis = this.phone.matches ? 1 : 2;
      function set(s, oo, anim) {
        var aa = Math.abs(oo), sg = oo < 0 ? -1 : 1;
        s.classList.toggle('no-anim', !anim);
        s.dataset.o = Math.max(-2, Math.min(2, oo));
        s.style.setProperty('--k1', aa === 1 || aa >= 3 ? sg : 0);
        s.style.setProperty('--k2', aa >= 2 ? sg : 0);
        s.classList.toggle('is-far', aa > vis);
        s._o = oo; s._far = aa > vis;
        s.tabIndex = oo === 0 ? 0 : -1;
        if (oo === 0) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
      }
      var anim = !this.reduce, half = anim ? SLIDE_MS / 2 : 0;
      this.slides.forEach(function (s, k) {
        var o = self.offset(k, dir);
        clearTimeout(s._wrapTimer);
        if (instant || s._o === undefined) { set(s, o, false); return; }
        if (Math.abs(o - s._o) > 1) {
          /* pindah sisi (paling kiri → paling kanan): keluar dulu ke luar layar, lalu masuk dari sisi seberang.
             Tidak pernah lewat di belakang sepatu lain. */
          set(s, s._o - dir, anim);
          s._wrapTimer = setTimeout(function () {
            set(s, o + dir, false); void s.offsetWidth; set(s, o, anim);
          }, half);
          return;
        }
        /* sepatu yang baru terlihat: taruh dulu di luar sisi datangnya, lalu geser masuk */
        if (s._far && Math.abs(o) <= vis) { set(s, o + dir, false); void s.offsetWidth; }
        set(s, o, anim);
      });
    }

    text() {
      var s = this.slides[this.i], tpl = s.querySelector('template[data-info]');
      if (this.infoTarget && tpl) {
        this.infoTarget.textContent = '';
        this.infoTarget.appendChild(tpl.content.cloneNode(true));
      }
      if (this.link) this.link.href = s.getAttribute('href') || '#';
      if (this.counter) this.counter.textContent = pad(this.i + 1) + ' / ' + pad(this.N);
    }

    loadAround() {
      if (!this.near || this.low || !this.autoplay) return;
      /* HP: versi 720p (lebih ringan), desktop: 1080p. Hanya sepatu tengah + berikutnya yang dimuat. */
      var N = this.N, self = this, key = this.phone.matches ? 'srcSd' : 'src';
      [this.i, this.i + 1].forEach(function (k) {
        var s = self.slides[(k % N + N) % N], v = s._v;
        if (v && !v.getAttribute('src') && v.dataset.src) {
          v.muted = true; v.defaultMuted = true; v.playsInline = true;
          v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
          v.preload = 'auto'; v.src = v.dataset[key] || v.dataset.src;
          if (v.load) v.load();
        }
      });
    }

    running() { return this.autoplay && this.inView && !this.paused && !document.hidden; }

    playCenter(force) {
      var c = this.slides[this.i], v = c._v;
      if (!this.running() || !v || c._bad || c._blocked || this.low) return;
      if (!v.getAttribute('src')) this.loadAround();
      if (!v.getAttribute('src')) return;
      clearTimeout(c._stop);
      if (!v.paused) return;
      /* jangan memanggil play() tiap frame: paling sering 1x per detik */
      var now = Date.now();
      if (!force && now - c._try < RETRY_MS) return;
      c._try = now;
      v.muted = true;
      /* iOS baru memuat video setelah play() dipanggil, jadi tidak menunggu readyState */
      var p = v.play();
      if (p && p.catch) p.catch(function (err) { if (err && err.name === 'NotAllowedError') c._blocked = true; });
    }

    go(k, dir) {
      if (this.N < 2) return;
      var prev = this.slides[this.i], self = this;
      this.i = (k % this.N + this.N) % this.N;
      this.spun = 0;
      var c = this.slides[this.i];
      c._last = null; c._wait = 0; c._still = 0; c._slow = false; c._try = 0;
      this.layout(dir || 1);
      this.text();
      this.loadAround();
      /* sepatu yang keluar tetap berputar selama bergeser (sudah blur), baru berhenti di akhir geser: tidak ada "patah" */
      if (prev !== c && prev._v) {
        clearTimeout(prev._stop);
        prev._stop = setTimeout(function () { if (self.slides[self.i] !== prev && prev._v) prev._v.pause(); }, this.reduce ? 0 : SLIDE_MS);
      }
      /* sepatu yang masuk langsung berputar sambil bergeser ke tengah */
      this.playCenter();
    }

    togglePause() {
      this.paused = !this.paused;
      this.classList.toggle('is-paused', this.paused);
      if (this.pauseBtn) this.pauseBtn.setAttribute('aria-label', this.paused ? this.dataset.labelPlay : this.dataset.labelPause);
      this.sync();
    }

    sync() {
      cancelAnimationFrame(this._raf); this._raf = 0; this._prev = 0;
      if (this.running()) {
        var self = this;
        this.slides[this.i]._last = null;
        this.playCenter();
        this._raf = requestAnimationFrame(function (t) { self.loop(t); });
      } else {
        this.slides.forEach(function (s) { clearTimeout(s._stop); if (s._v && !s._v.paused) s._v.pause(); });
      }
    }

    /* satu loop ringan: hanya membaca waktu video tengah untuk menghitung 1 putaran */
    loop(ts) {
      var self = this, dt = this._prev ? Math.min(0.05, (ts - this._prev) / 1000) : 0;
      this._prev = ts;
      var c = this.slides[this.i], v = c._v;
      /* video dipakai kalau ada, tidak error, tidak diblokir, dan tidak lambat dimuat */
      if (v && v.dataset.src && !c._bad && !c._blocked && !c._slow && !this.low) {
        if (v.paused) this.playCenter();
        if (v.readyState >= 2 && v.duration) {
          var t = v.currentTime;
          if (c._last !== null) {
            var d = t - c._last; if (d < 0) d += v.duration;
            if (d > 0 && d < 1) { this.spun += d; c._still = 0; } else { c._still += dt; }
          }
          c._last = t;
          if (this.spun >= v.duration - 0.04) this.next();
          else if (c._still > STALL) { c._slow = true; }   /* macet: lanjut geser pakai poster */
        } else if ((c._wait += dt) > LOAD_TIMEOUT) {
          c._slow = true;                                    /* terlalu lama dimuat: geser pakai poster */
          this.spun = Math.max(this.spun, c._wait);          /* waktu tunggu ikut dihitung: total tetap ±4 dtk */
        }
      } else {
        this.spun += dt;
        if (this.spun >= IMAGE_DWELL) this.next();
      }
      this._raf = requestAnimationFrame(function (t2) { self.loop(t2); });
    }

    next() {
      if (this.N > 1) this.go(this.i + 1, 1);
      else { this.spun = 0; }
    }
  }

  customElements.define('spotec-spin-360', SpotecSpin360);
})();
